export const TOOLTIP_DISPLAY_DELAY = 700;